module.exports = "https://cdn.littlereply.com/tt/resource/arrow_all_post.65a5fc5959d1bea4757a48a06723b187.png";